module.exports = __webpack_public_path__ + "img/user.14eefe08.svg";